import { t } from 'i18next';

export const twoDigitsNumber = (num: number) => (num > 9 ? '' : '0') + num;
export const timeFormatter = (number: number) => {
  const seconds = number % 60;
  const minutes = Math.floor((number / 60) % 60);
  const secondsText = seconds ? t('time.second', { count: seconds }) : '';
  const minutesText = minutes ? t('time.minute', { count: minutes }) : '';
  return `${minutesText} ${secondsText}`;
};

export const timeLeftInMinutesFormatter = (number: number) => {
  const minutes = Math.max(Math.ceil((number / 60) % 60), 1);
  return t('time.minuteLeft', { count: minutes });
};

export const timerCountDown = (number: number) => {
  const seconds = number % 60;
  const minutes = Math.floor((number / 60) % 60);
  const formattedSeconds = `${(seconds > 9 ? '' : '0') + seconds}`;
  const formattedMinutes = `${(minutes > 9 ? '' : '0') + minutes}`;
  return [formattedMinutes, formattedSeconds];
};

export const formattedDuration = (number: number) => {
  const seconds = Math.floor(number % 60);
  const minutes = Math.floor((number / 60) % 60);
  return `${twoDigitsNumber(minutes)}:${twoDigitsNumber(seconds)}`;
};
